import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPolicy } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/privacy-policy")({
  head: () => seoHead(SEO.privacyPolicy),
  component: PrivacyPolicy,
});
